import React from 'react';
import './CloseablePage.css';
import CloseIcon from '../../components/CloseIcon';
import PropTypes from 'prop-types';

function CloseablePage({ children, closeUrl = '/' }) {
  return (
    <div className="closeable-container">
      <div className="closeable-window">
        <div className="closeable-content">{children}</div>
        <CloseIcon url={closeUrl} />
      </div>
    </div>
  );
}

CloseablePage.propTypes = {
  children: PropTypes.element,
  closeUrl: PropTypes.string
};

export default CloseablePage;



// WEBPACK FOOTER //
// ./src/containers/CloseablePage/index.js